import { stateFactoryKey, type StateFactory } from '@/injectionKeys';
import type { ReservationSectionGaEventState } from '@/wabunka-src/common/features/Reservation/core/accordion/sectionGaEvents';
import type { ReservationQuestionGaEventState } from '@/wabunka-src/common/features/Reservation/core/reservationQuestionGaEvents';

export interface States {
  addGuestInfoEventSent: boolean;
  reservationQuestionGaEventState: ReservationQuestionGaEventState;
  reservationSectionGaEventState: ReservationSectionGaEventState;
}

export type StateKeys = keyof States;

export const useWabunkaStateFactory = <T extends StateKeys>(key: T, init: States[T]) => {
  const stateFactory = inject(stateFactoryKey) as StateFactory;
  const state = stateFactory.create<States[T]>(key, init);

  return state;
};
